import workspaceQuery from 'graphql/queries/diary/DiaryTypeWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/diary/DiaryTypeListQuery.graphql';
import instanceQuery from 'graphql/queries/diary/DiaryTypeQuery.graphql';
import defaultQuery from 'graphql/queries/diary/DiaryTypeDefault.graphql';
import mutationQuery from 'graphql/mutations/diary/DiaryTypeMutation.graphql';
import fragment from 'graphql/fragments/diary/DiaryTypeFragment.graphql';

const Type = {
  type: 'EventType',
  title: 'Task Types',
  formTitle: 'Task Type',
  formUrl: '/Diary/TaskType/Details/',
  workspaceUrl: '/Diary/TaskType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    remoteFilter: true,
    preLoad: true,
  },
  fragment,
  screenReference: 'DIARY_TASK_TYPES',
};

export default Type;
